import { Component, OnChanges, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { AccidentsService } from '../services/accidents/accidents.service';
import { DialogAccidents } from '../dialog/accidents/dialog.component.acc';
import { ListService } from '../list.service';
import { saveAs } from 'file-saver';

import { IAccident, IAccidentResponse } from './accidents.interfaces';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-accidents',
  templateUrl: './accidents.component.html',
  styleUrls: [ './accidents.component.css' ],
  providers: [ AccidentsService, ListService ]
})
export class AccidentsComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public accidentsData: IAccidentResponse;
  public userInfo: any = {};
  
  private activeFilters: any = {};
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  private unsubscriber : Subject<void> = new Subject<void>();
  public showFilters: boolean = true;
  public export: boolean = false;
  public orderingParameters: any;

  private accidentModel: IAccident = {
      'id': '',
      'plate': 'NEW',
      'date': '',
      'time': '',
      'location': '',
      'parish': '',
      'number_of_fatalities': null,
      'number_of_injuries': '',
      'number_of_vehicles': '',
      'number_of_pedestrians': '',
      'number_of_cyclists': '',
      'main_cause': '',
      'long': '',
      'lat': '',
      'involved_plates': ''
     };
  public error: string = '';
  public showDialog: boolean = false;
  public editAccidentsData: IAccident;

  public exportar(){this.export=true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public addAccident(): void {
    this.editAccidentsData = Object.assign( {}, this.accidentModel, { plate: 'NEW' } );
    let dialogFactRef=this.dialog.open(DialogAccidents, {disableClose: true, width: '85vw', height: '85vh',  maxWidth: '95vw',  maxHeight: '95vh', data: {dades: this.editAccidentsData, user: this.userInfo} })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editAccidentsData = results;
      this.addOrUpdate();
    });
  }

  public editAccident(accident: IAccident): void {
    this.editAccidentsData = Object.assign( {}, this.accidentModel, accident );
    let dialogFactRef=this.dialog.open(DialogAccidents, {width: '85vw', height: '85vh',  maxWidth: '95vw',  maxHeight: '95vh', data: {dades: this.editAccidentsData, user: this.userInfo} })

    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editAccidentsData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    if (this.editAccidentsData.plate === 'NEW') {
      this.accidentService.create(this.editAccidentsData)
        .subscribe(newContacte => {console.log("S'ha creat l'element");this.router.navigate(['accidents']);});
    } else {
      this.accidentService.update(<string> this.editAccidentsData.plate, this.editAccidentsData)
        .subscribe(updatedContacte => {console.log("S'han desat les dades");this.router.navigate(['accidents']);});
        //Actualitza la llista amb les modificacions
        let updateItem = this.accidentsData.rows.find(item => item.plate == this.editAccidentsData.plate);
        let index = this.accidentsData.rows.indexOf(updateItem);
        this.accidentsData.rows[index] = this.editAccidentsData;
    }
  }

  public gotoPage(page: number): void {
    this.listAccidentsService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event){
    if(this.currentOrdering.length == 0)['nom'].map(item => this.currentOrdering[item] = this.orderingCycle[1]);
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listAccidentsService.currentPage * this.listAccidentsService.rowsPerPage;
    this.requestRowsToParent();
   }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listAccidentsService.currentPage * this.listAccidentsService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listAccidentsService.rowsPerPage - 1, this.accidentsData.registers);
  }

  private requestRowsToParent(): void {
    this.accidentService.getList(
      this.listAccidentsService.rowsPerPage, //Limit
      this.listAccidentsService.currentPage*this.listAccidentsService.rowsPerPage, //Skip
      this.activeFilters //FILTRE DE LS PROPIETARIS QUE ES MOSTREN A INICI
      ,{}//Conds a aplicar. Per defecte LIKE %%
      ,this.currentOrdering //ORDRE DELS PROPIETARIS QUE ES MOSTREN A INICI
      ,this.export
    ).subscribe(
      data => {
        if(!this.export){this.accidentsData = data;this.computeDisplayedRows();}
        else{
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export.csv");
        }
      },
      error => console.log(error)
    );
  }

  public requestPrevious(): void {
     this.listAccidentsService.currentPage = Math.max(0, this.listAccidentsService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listAccidentsService.currentPage = this.listAccidentsService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
     this.listAccidentsService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
  }

  public accidentsFilters: Array<any>
  public ordreCamps: Array<any>
  public tableFields: Array<any>

  constructor(public tokenStorage: TokenStorageService, public listAccidentsService: ListService, public dialog:MatDialog, private accidentService: AccidentsService, private router: Router, private route: ActivatedRoute) {
  this.userInfo = this.tokenStorage.getUser();}

  ngOnInit() {
    this.ordreCamps = ['id'];

    this.tableFields = [
      ['id', 'Id'],
      ['plate', 'Plate'],
      ['date', 'Date'],
      ['time', 'Time'],
      ['parish', 'Parish'],
      ['number_of_fatalities', 'Fatalities'],
      ['number_of_injuries', 'Injuries'],
      ['number_of_vehicles', 'Vehicles'],
      ['primary_cause', 'Cause']
    ];

    this.accidentsFilters = [
    {
      inputs: []
    },
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
 {
                text: 'Plate',//Text a mostrar label
                name: 'plate',//Camp de la base de dades
                autocomplete: 'plate',//Crida per obtenir els valors si autocomplete
                value: this.listAccidentsService.getSearchValues('text')//valor a mostrar
              },              {
                text: 'Parish',
                name: 'parish',
                autocomplete: 'parish',
                value: this.listAccidentsService.getSearchValues('text')
              },
              {
                text: 'Type',
                name: 'primary_cause',
                autocomplete: 'cause',
                value: this.listAccidentsService.getSearchValues('text')
              }
          ]
        }
      ]
    }
  ];

  this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    ['id'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
 
    const id = this.route.snapshot.paramMap.get('id');
    
    if (id) {
      this.computeActiveFilters({ id: id });
    } else {
      this.computeActiveFilters({});
    }

    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
      this.unsubscriber.next();
      this.unsubscriber.complete();
  }

  go(lloc, id){this.router.navigate([lloc, id]);}

}
